


































import Vue from 'vue'

interface OutputData {
  currentValue: string | number;
  currentCheks: string[];
}
interface InputData {
    id: string;
    label: string;
    value: string;
    name: string;
}

export default Vue.extend({
  name: 'RadioCheckGroup',
  props: {
    items: {
      type: Array as () => InputData[],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    selected: {
      type: String,
      default: '',
      required: false
    },
    changeType: {
      type: Boolean,
      default: false,
      required: false
    },
    selectedChecks: {
      type: Array as () => string[],
      required: false
    },
    inline: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data (): OutputData {
    return {
      currentValue: '',
      currentCheks: []
    }
  },
  watch: {
    selected (newVal: string) {
      this.currentValue = newVal
    },
    currentCheks () {
      this.$emit('checksCheked', this.currentCheks)
    }
  },
  mounted (): void {
    if (this.changeType) {
      this.currentCheks = this.selectedChecks !== undefined ? this.selectedChecks : []
    } else {
      this.currentValue = this.selected
    }
  }
})
